import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Placeholder from 'flarum/common/components/Placeholder';
import Button from 'flarum/common/components/Button';
import LinkButton from 'flarum/common/components/LinkButton';
import extractText from 'flarum/common/utils/extractText';
import humanTime from 'flarum/common/utils/humanTime';
export default class ExpLogPage extends UserPage {
  records = [];
  loading = true;
  nomore = false;
  page = 0;
  oninit(vnode) {
    super.oninit(vnode);
    this.loadUser(m.route.param('username'));
    this.loadRecords();
  }
  loadRecords() {
    app.store.find('exp-logs', {
      page: {
        offset: this.page * 10
      }
    }).then(records => {
      this.records = this.records.concat(records);
      this.loading = false;
      if (records.length < 10) {
        this.nomore = true;
      }
      m.redraw();
    });
  }
  loadMore() {
    this.page += 1;
    this.loadRecords();
  }
  content() {
    if (this.records.length === 0) {
      return m(Placeholder, {
        text: app.translator.trans('foskym-custom-levels.forum.log.no_records')
      });
    }
    let levelText = '',
      expText = '',
      expTooltip = '';
    levelText = app.forum.attribute('foskym-custom-levels.levelText') || extractText(app.translator.trans('foskym-custom-levels.lib.defaults.level'));
    expText = app.forum.attribute('foskym-custom-levels.expText') || extractText(app.translator.trans('foskym-custom-levels.lib.defaults.exp'));
    expTooltip = app.forum.attribute('foskym-custom-levels.expTooltip') || extractText(app.translator.trans('foskym-custom-levels.lib.defaults.tooltip'));
    return m("div", {
      className: "ExpLogPage"
    }, m("ul", {
      className: "ExpLogRecords"
    }, this.records.map(record => m("li", {
      className: "ExpLogRecord"
    }, m("h5", null, m("span", null, (record.exp() > 0 ? '+' : '') + (expText.indexOf('[expTotal]') > -1 ? expText.replace('[expTotal]', record.exp()) : record.exp() + ' ' + expText)), m("span", null, humanTime(record.created_at()))), m("p", null, app.translator.trans('foskym-custom-levels.forum.log.type.' + record.type(), {
      title: record.type() === 'forum_quests' ? record.relationship().quest_name : record.relationship().discussion_title || ''
    }), m("span", null, record.relationship().post_id ? m(LinkButton, {
      href: '/d/' + record.relationship().discussion_id + '/' + record.relationship().post_number,
      target: "_blank"
    }, app.translator.trans('foskym-custom-levels.forum.log.view')) : record.relationship().discussion_id ? m(LinkButton, {
      href: '/d/' + record.relationship().discussion_id,
      target: "_blank"
    }, app.translator.trans('foskym-custom-levels.forum.log.view')) : record.type() === 'forum_quests' && 'xypp-forum-quests' in flarum.extensions ? m(LinkButton, {
      href: '/quest_page',
      target: "_blank"
    }, app.translator.trans('foskym-custom-levels.forum.log.view')) : record.type() === 'store_purchase' && 'xypp-store' in flarum.extensions ? m(LinkButton, {
      href: '/u/' + m.route.param('username') + '/purchase_history'
    }, app.translator.trans('foskym-custom-levels.forum.log.view')) : '')), m("hr", null)))), this.loading && m(LoadingIndicator, {
      display: "block"
    }), !this.loading && !this.nomore && m("div", {
      style: "text-align:center;padding:20px"
    }, m(Button, {
      className: 'Button Button--primary',
      disabled: this.loading,
      loading: this.loading,
      onclick: () => this.loadMore()
    }, app.translator.trans('foskym-custom-levels.forum.log.load_more'))), this.nomore && m(Placeholder, {
      text: app.translator.trans('foskym-custom-levels.forum.log.no_more')
    }));
  }
}
flarum.reg.add('foskym-custom-levels', 'forum/components/ExpLogPage', ExpLogPage);